import * as React from "react"
import type { SVGProps } from "react"
const SvgBreakLink = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m15.63 12.92-1.78-1.78H15a.97.97 0 0 1 1 1 1 1 0 0 1-.1.45 1 1 0 0 1-.28.33m4.87 9.12a1 1 0 0 1-.7.28 1 1 0 0 1-.7-.28l-17-17a1 1 0 0 1-.27-.7q0-.42.27-.7a1 1 0 0 1 .7-.27q.42 0 .7.27l17 17a1 1 0 0 1 .28.7 1 1 0 0 1-.28.7M7 17.14a4.8 4.8 0 0 1-3.54-1.46A4.8 4.8 0 0 1 2 12.14q0-1.72 1.05-3.07t2.7-1.78L7.6 9.14H7q-1.25 0-2.12.88A3 3 0 0 0 4 12.14q0 1.26.88 2.13a3 3 0 0 0 2.12.87h3a.97.97 0 0 1 1 1q0 .43-.29.72a1 1 0 0 1-.71.28zm2-4a1 1 0 0 1-.71-.28 1 1 0 0 1-.29-.72q0-.42.29-.71a1 1 0 0 1 .71-.29h.63l1.97 2zm9.5 2.8a1 1 0 0 1-.16-.75 1 1 0 0 1 .41-.62q.58-.42.91-1.05t.34-1.38q0-1.25-.87-2.12A3 3 0 0 0 17 9.14h-3a1 1 0 0 1-.71-.28 1 1 0 0 1-.29-.72q0-.42.29-.71a1 1 0 0 1 .71-.29h3q2.07 0 3.54 1.47A4.8 4.8 0 0 1 22 12.14a5 5 0 0 1-.56 2.29 5 5 0 0 1-1.57 1.76q-.34.22-.75.16a1 1 0 0 1-.62-.4" />
  </svg>
)
export default SvgBreakLink
